/**
 *  Predictor game process status
 */
export enum PredictorProcessStatus {
  //**Ready Status/
  Ready = 0,
  //**Processing Status/
  Processing = 1,
  //**Processed Status/
  Processed = 2,
  //**Failed Status/
  Failed = 3,
}
